import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectLinkGroupsInStore,
  selectLinkGroupsPageLoading,
  selectLinkGroupsShowInitWaitingMessage,
} from '../_selectors/link-group.selectors';

export class LinkGroupsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectLinkGroupsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectLinkGroupsShowInitWaitingMessage));

    this.store.pipe(select(selectLinkGroupsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
